import useEditCharacterSkill from '../composables/useEditCharacterSkill'
//---------------------------------
// update character skills harness
//---------------------------------
// export default async function useUpdateCharacterSkillsHarness(
//   changed_skills,
//   { returnResponses = false } = {},
export default async function useUpdateCharacterSkillsHarness(changed_skills) {
  console.log('---------------------------------------')
  console.log('IN useUpdateCharacterSkillsHarness')
  //-----------------------------------------------------------------------------------------------
  // manages all character skill updates (CRUD) e.g. skill ticks, training, new skills & deletions
  //-----------------------------------------------------------------------------------------------
  const results = []

  //----------------------------------------------
  // process skill updates sequentially so parent
  // skills are persisted before dependent children
  //----------------------------------------------
  for (const s of changed_skills) {
    console.log('IN useUpdateCharacterSkillsHarness - PROCESSING SKILL:', s)
    results.push(await useEditCharacterSkill(s))
  }
  //-----------------------------
  // optionally return responses
  //-----------------------------
  // if (returnResponses) return results
  return results
  //----------------------------------------------
  // else no response (caller awaited completion)
  //----------------------------------------------
  // return
}
